import { useState } from 'react';

const useAddField = ({ form, name, initialNumOfFields = 0 }) => {
  const { getFieldDecorator, setFieldsValue, getFieldValue } = form;

  const [id, setId] = useState(initialNumOfFields);

  const remove = (k) => {
    const keys = getFieldValue(name);

    setFieldsValue({
      [name]: keys.filter((key) => key !== k),
    });
  };

  const add = () => {
    const keys = getFieldValue(name);
    const nextKeys = keys.concat(id);
    setId((prev) => prev + 1);

    setFieldsValue({
      [name]: nextKeys,
    });
  };

  const getInitialValue = () => {
    if (initialNumOfFields <= 0) {
      return [];
    } else {
      let arr = [];

      for (let i = 0; i < initialNumOfFields; i++) {
        arr.push(i);
      }

      return arr;
    }
  };

  getFieldDecorator(name, { initialValue: getInitialValue() });

  const keys = getFieldValue(name);

  return {
    keys,
    add,
    remove,
  };
};

export default useAddField;
